// Catálogo de indicadores de composição corporal — mesmas faixas de
// referência usadas no card do dashboard (App.js), extraído aqui pra ser
// reaproveitado pela aba dedicada de Composição Corporal sem duplicar as
// faixas em dois lugares que possam divergir.
export const bcRange = (v, faixas) => {
  for (const [limite, texto, classe] of faixas) if (v < limite) return [texto, classe];
  return null;
};

export const BC_INDICATORS = [
  { key: 'imc', icon: '📐', label: 'IMC', unit: '',
    status: (v) => bcRange(v, [[18.5, 'Baixo', 'low'], [25, 'Saudável', 'good'], [30, 'Alto', 'warn'], [Infinity, 'Obeso', 'bad']]) },
  { key: 'fat_pct', icon: '🥓', label: 'Gordura', unit: '%',
    status: (v) => bcRange(v, [[11, 'Baixo', 'low'], [22, 'Saudável', 'good'], [28, 'Alto', 'warn'], [Infinity, 'Muito alto', 'bad']]) },
  { key: 'fat_kg', icon: '🧈', label: 'Peso da gordura', unit: 'kg' },
  { key: 'skeletal_muscle_pct', icon: '💪', label: 'Massa muscular esquelética', unit: '%',
    status: (v) => bcRange(v, [[33, 'Baixo', 'low'], [40, 'Saudável', 'good'], [Infinity, 'Excelente', 'top']]) },
  { key: 'muscle_score_pct', icon: '🏋️', label: 'Registro de massa muscular', unit: '%',
    status: (v) => bcRange(v, [[69, 'Baixo', 'low'], [Infinity, 'Saudável', 'good']]) },
  { key: 'muscle_kg', icon: '🦾', label: 'Peso da massa muscular', unit: 'kg' },
  { key: 'visceral_fat', icon: '🫁', label: 'Gordura visceral', unit: '',
    status: (v) => bcRange(v, [[10, 'Saudável', 'good'], [15, 'Alto', 'warn'], [Infinity, 'Muito alto', 'bad']]) },
  { key: 'water_pct', icon: '💧', label: 'Água', unit: '%',
    status: (v) => bcRange(v, [[50, 'Baixo', 'low'], [66, 'Saudável', 'good'], [Infinity, 'Alto', 'warn']]) },
  { key: 'water_kg', icon: '🚰', label: 'Peso da água', unit: 'kg' },
  { key: 'metabolism_kcal', icon: '🔥', label: 'Metabolismo', unit: 'kcal/dia' },
  { key: 'obesity_pct', icon: '📊', label: 'Obesidade', unit: '%',
    status: (v) => bcRange(v, [[10, 'Saudável', 'good'], [20, 'Suavemente', 'warn'], [Infinity, 'Alto', 'bad']]) },
  { key: 'bone_kg', icon: '🦴', label: 'Ossos', unit: 'kg' },
  { key: 'protein_pct', icon: '🥚', label: 'Proteína', unit: '%',
    status: (v) => bcRange(v, [[16, 'Baixo', 'low'], [20, 'Saudável', 'good'], [Infinity, 'Alto', 'warn']]) },
  { key: 'lbm_kg', icon: '🧬', label: 'LBM (massa magra)', unit: 'kg' },
  { key: 'metabolic_age', icon: '⏳', label: 'Idade metabólica', unit: 'anos' },
];

// Mesmas cores dos status (good/top/warn/bad/low) — viram a cor de
// preenchimento das barras arredondadas (Atividades, Composição Corporal).
export const STATUS_COLORS = {
  good: '#22c55e',
  top: '#10b981',
  warn: '#f59e0b',
  bad: '#ef4444',
  low: '#38bdf8',
};

export const fmtMeasuredAt = (iso) => {
  if (!iso) return '';
  const [d, t] = iso.split('T');
  const [y, m, day] = d.split('-');
  return `${day}/${m}/${y} ${t || ''}`.trim();
};
